import { Stack, FormControl, InputLabel, Input, FormLabel, RadioGroup, FormControlLabel, Radio, Checkbox, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import { ButtonLink } from '../../subs/ButtonLink';

import { WSTestingProductPairValue } from '../../types/WSTestingData';

export const TestingPairServerData = ({ productPairData }: { productPairData: WSTestingProductPairValue | null }) => {

    return <>
        {productPairData && <form id='TestingPairServer'>
            <fieldset disabled={true} className={'disabledForm'}>
                <Stack direction={'column'} rowGap={30}>
                    <Grid container rowGap={20} columnSpacing={20}>
                        <Grid size={{ xs: 4 }}>
                            <FormControl required fullWidth>
                                <InputLabel>{"Product name"}</InputLabel>
                                <Input value={productPairData.serverProduct.productName ?? ""} disabled />
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 4 }}>
                            <FormControl required fullWidth>
                                <InputLabel>{"Product version"}</InputLabel>
                                <Input value={productPairData.serverProduct.productVersion ?? ""} disabled />
                            </FormControl>
                        </Grid>
                        <Grid size={{ xs: 4 }}>
                                <FormControl required>
                                    <FormLabel>{"Provider ready to test?"}</FormLabel>
                                <RadioGroup name='serverRadioButtons' row value={productPairData.serverProduct.readyToTest ? 'true' : 'false'}>
                                        <FormControlLabel value={'true'} control={<Radio />} label={"Yes"} />
                                        <FormControlLabel value={'false'} control={<Radio />} label={"No"} />
                                    </RadioGroup>
                                </FormControl>
                        </Grid>

                        <Grid container size={{ xs: 12 }}>
                            <Grid container size={{ xs: 12 }} >
                                <FormControl required>
                                    <FormLabel>{"Supported Interfaces"}</FormLabel>
                                    {productPairData.serverProduct.productPairInterfaceData && productPairData.serverProduct.productPairInterfaceData.map(wi => {
                                        return <Grid container size={{ xs: 12 }}>
                                            <FormControlLabel control={<Checkbox checked={wi.supportedByProduct ? true : false} disabled />}
                                                label={wi.name} />
                                        </Grid>;
                                    })}
                                </FormControl>
                            </Grid>

                            <Grid container size={{ xs: 12 }}>
                                <FormControl fullWidth>
                                    <FormLabel>{"ServerProgID / URL"}</FormLabel>
                                    {productPairData.serverProduct.productPairInterfaceData && productPairData.serverProduct.productPairInterfaceData.map(wi => {
                                        return <Grid height={'100%'}>
                                            {<TextField size='small' fullWidth
                                                    disabled={true}
                                                value={wi.serverEndpoint} />}
                                        </Grid>
                                    })}
                                </FormControl>
                            </Grid>
                        </Grid>

                        <Grid container size={{ xs: 12 }}>
                            <Grid container size={{ xs: 6 }}>
                                <ButtonLink key={`Start${productPairData.workshopId}`} to={`/ViewUserProducts/${productPairData.workshopId}`} >
                                    Edit Products
                                </ButtonLink>
                            </Grid>
                            <Grid container size={{ xs: 6 }}>

                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12 }}>
                            <FormControl fullWidth>
                                <TextField label={"Product description"} variant='outlined' multiline minRows={7} maxRows={7} fullWidth
                                    value={productPairData.serverProduct.description ?? ""} />
                            </FormControl>
                        </Grid>
                    </Grid>
                </Stack>
            </fieldset>
        </form>}
    </>
}